import { InputAdornment } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';
import { stopHasCargo } from '../../../../../constants/constants';
import { Stop } from '../../../../../types';
import { convertBushelsToGrams, convertGramsToBushels } from '../../../../../utils/weight-utils';
import { useWeights } from '../../../../shared/hooks/use-weights';
import { ValidatedTextField } from '../../../../shared/inputs/validated-text-field';
import { useDraftLoadContext } from '../../../hooks/draft-load-context';
import { useDraftLoadStopContext } from '../../../hooks/draft-load-stop-context';
import { editableStopInputProps } from '../../../table-components/stops/editable-stop-table-row';
import { getQuantityWeightValidations } from './get-quantity-weight-validations';

interface EditableStopBushelsProps {
    stop: Stop;
    isValidated?: boolean;
    property: 'weight' | 'actualWeight';
}

export const EditableStopBushels = ({ stop, isValidated, property }: EditableStopBushelsProps) => {
    const { editedLoad } = useDraftLoadContext();
    const { onEditedStopChanged, isCarrier, isComplete } = useDraftLoadStopContext();
    const { convertFromGrams, weightPrecision } = useWeights();
    
    const initialValue = convertGramsToBushels(stop[property] || 0, stop.cargoTypeId || -1) || '';
    const [localValue, setLocalValue] = React.useState(initialValue);

    if (!stopHasCargo(stop)) {
        return null;
    }

    const validations = isValidated
            ? getQuantityWeightValidations(editedLoad, convertFromGrams, weightPrecision)
            : undefined;

    return (
        <ValidatedTextField
            type='number'
            disabled={isCarrier || isComplete}
            value={localValue}
            inputProps={{ min: 0, step: .01, ...editableStopInputProps }}
            fullWidth
            onChange={(e) => {
                setLocalValue(e.target.value);
            }}
            onBlur={(e) => {
                const changedWeight = Number(localValue);
                const grams = convertBushelsToGrams(changedWeight, stop.cargoTypeId || -1);
                onEditedStopChanged({ [property]: grams || null });
            }}
            InputProps={{
                endAdornment: <InputAdornment position='end'>{L.unitsBushelAbbr()}</InputAdornment>,
            }}
            validations={validations}
        />
    );
};